// Styles for OffersCardLayered go here.
import styled from 'styled-components';

export const StyledOffersCardLayered = styled.div``;
